import ThemeProvider from './ThemeProvider';

export default ThemeProvider;
